import moment from 'moment';

export const recursiveMap = (o, cb) => {
  const keys = Object.keys(o);
  return keys.reduce((acc, k) => {
    const toString = Object.prototype.toString;
    const isObject = toString.call(o[k]) === '[object Object]' && !moment.isMoment(o[k]);
    acc[k] = isObject ? recursiveMap(o[k], cb) : cb(o[k], k);
    return acc;
  }, {});
};

export const arrayToObject = (arr) =>
  arr.reduce(
    (acc, o) => ({
      ...acc,
      ...o
    }),
    {}
  );

export const convertDatesToMoment = (o, keys = []) =>
  recursiveMap(o, (v, k) => {
    const isMoment = moment.isMoment(v);
    const isValid = moment(v, moment.ISO_8601).isValid();
    const toString = Object.prototype.toString;
    const isString = toString.call(v) === '[object String]';

    if (!keys.includes(k)) {
      return v;
    }

    if (isMoment) {
      return v;
    }

    if (!isMoment && isString && isValid) {
      return moment(v);
    }

    return v;
  });
